import { render, staticRenderFns } from "./SuggestedAddressComponent.vue?vue&type=template&id=e2125b28&scoped=true"
import script from "./SuggestedAddressComponent.vue?vue&type=script&lang=ts"
export * from "./SuggestedAddressComponent.vue?vue&type=script&lang=ts"
import style0 from "./SuggestedAddressComponent.vue?vue&type=style&index=0&id=e2125b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2125b28",
  null
  
)

export default component.exports